import isValid from "date-fns/isValid";

const parseDate = (value?: unknown): Date | undefined => {
  if (!value) {
    return undefined;
  }

  if (
    value instanceof Date ||
    typeof value === "string" ||
    typeof value === "number"
  ) {
    const dateValue = new Date(value);

    if (!isValid(dateValue)) {
      throw new Error(`Invalid date value: "${value}"`);
    }

    return dateValue;
  }

  return undefined;
};

export default parseDate;
